import { LockClosedIcon } from '@heroicons/react/24/outline'
import parse from 'html-react-parser'
import { ReactNode } from 'react'
import { classNames } from '../../_helpers'
import { INFOTEXT_CLASS, INPUT_CLASS, LABEL_CLASS } from './styles'

type PropType = {
  label: string;
  value: string;
  small?: boolean;
  labelPadding?: boolean;
  setValue: (value: string) => void;
  children: ReactNode
  isRequired?: boolean
  vertical?: boolean
  disabled?: boolean
  isPrivate?: boolean
  className?: string
  infotext?: string
}

export const Selectfield = ({ label, value, setValue, children, small, isRequired, disabled, isPrivate, className, infotext }: PropType) => {
  return (
    <label className={classNames('block', className)}>
      <span className={classNames(LABEL_CLASS, 'mb-1.5', small ? 'text-xs' : 'text-sm')}>
        {isPrivate && (
          <LockClosedIcon className={'w-4 h-4 mr-2 shrink-0'} />
        )}
        {label}
      </span>
      {infotext && (
        <div className={INFOTEXT_CLASS}>{parse(infotext)}</div>
      )}
      <select
        value={value}
        onChange={e => setValue(e.target.value)}
        required={isRequired}
        disabled={disabled}
        className={classNames(INPUT_CLASS, 'ui-select max-w-xl pr-8', small ? 'text-xs' : 'text-sm')}
      >
        <option value={''}>Bitte wählen...</option>
        {children}
      </select>
    </label>
  )
}
